import React from "react";
import "../style/Footer.scss";
import logoBlack from "../assets/images/Footer/logo_black.png";
import logoTwitter from "../assets/images/Footer/logo_twitter.png";
import logoDiscord from "../assets/images/Footer/logo_discord.png";

function Footer(props) {
  const onClickNav = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id={"Footer"}>
      <div className="footer-wrapper">
        <img className="company-logo" src={logoBlack} alt={''}/>
        <div className="company-wrapper">
          <div className="company-name">VERIA NETWORK © 2024</div>
          <div className="company-link-wrapper">
            <div className="link-text">JOIN US : </div>
            <img src={logoTwitter} alt="" className="sns-img first"/>
            <img src={logoDiscord} alt="" className="sns-img"/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
